import { setPreview } from '../lib/spriteCache';
import { SpriteRecord } from '../types/sprites';
import React from 'react';

export function useThumbFallback(setSprites: React.Dispatch<React.SetStateAction<any[]>>) {
  return (sp: SpriteRecord) => (ev: React.SyntheticEvent<HTMLImageElement>) => {
    if (sp.__pixelFallback) {
      setSprites(list => list.map(it => it.id === sp.id ? { ...it, previewUrl: sp.__pixelFallback } : it));
      try {
        const updated = sp.updated ?? sp.updatedAt ?? (sp as any).updated_at ?? 0;
        setPreview(sp.id, updated, sp.__pixelFallback);
      } catch {}
    } else {
      (ev.currentTarget).style.display = 'none';
    }
  };
}